/**
 * 欧洲站点 FBA 费率配置
 * 包括: UK, DE, FR, IT, ES
 */
import { SiteConfig } from '../types';

export const UK_CONFIG: SiteConfig = {
    currency: '£',
    lowPriceThreshold: 10.00,
    storageFees: {
        standard: { jan_sep: 0.86, oct_dec: 1.10, unit: 'cu_ft' },
        oversize: { jan_sep: 0.60, oct_dec: 0.90, unit: 'cu_ft' }
    },
    peakSurcharge: {
        standard: 0.10,
        oversize: 0.50
    },
    sizeTiers: {
        standard: [
            { tierName: 'Small Envelope (80g)', maxWeight: 0.08, maxEdge: [20, 15, 1], fee: 1.63, unit: 'g' },
            { tierName: 'Standard Envelope (100g)', maxWeight: 0.1, maxEdge: [33, 23, 2.5], fee: 1.81, unit: 'g' },
            { tierName: 'Large Envelope (960g)', maxWeight: 0.96, maxEdge: [33, 23, 5], fee: 2.58, unit: 'g' },
            { tierName: 'Standard Parcel (150g)', maxWeight: 0.15, maxEdge: [45, 34, 26], fee: 2.56, unit: 'g' },
            { tierName: 'Standard Parcel (400g)', maxWeight: 0.4, maxEdge: [45, 34, 26], fee: 2.68, unit: 'g' },
            { tierName: 'Standard Parcel (900g)', maxWeight: 0.9, maxEdge: [45, 34, 26], fee: 2.90, unit: 'g' },
            { tierName: 'Standard Parcel (1.9kg)', maxWeight: 1.9, maxEdge: [45, 34, 26], fee: 4.08, unit: 'kg' },
        ],
        lowPrice: [
            { tierName: 'Small Envelope (80g)', maxWeight: 0.08, maxEdge: [20, 15, 1], fee: 1.34, unit: 'g' },
            { tierName: 'Standard Envelope (100g)', maxWeight: 0.1, maxEdge: [33, 23, 2.5], fee: 1.50, unit: 'g' },
            { tierName: 'Large Envelope (960g)', maxWeight: 0.96, maxEdge: [33, 23, 5], fee: 2.12, unit: 'g' },
            { tierName: 'Standard Parcel (150g)', maxWeight: 0.15, maxEdge: [45, 34, 26], fee: 2.15, unit: 'g' },
            { tierName: 'Standard Parcel (400g)', maxWeight: 0.4, maxEdge: [45, 34, 26], fee: 2.25, unit: 'g' },
        ]
    }
};

export const DE_CONFIG: SiteConfig = {
    currency: '€',
    lowPriceThreshold: 11.00,
    storageFees: {
        standard: { jan_sep: 26.00, oct_dec: 31.00, unit: 'cbm' },
        oversize: { jan_sep: 18.00, oct_dec: 22.00, unit: 'cbm' }
    },
    sizeTiers: {
        standard: [
            { tierName: 'Small Envelope (80g)', maxWeight: 0.08, maxEdge: [20, 15, 1], fee: 1.96, unit: 'g' },
            { tierName: 'Standard Envelope (100g)', maxWeight: 0.1, maxEdge: [33, 23, 2.5], fee: 2.17, unit: 'g' },
            { tierName: 'Standard Parcel (150g)', maxWeight: 0.15, maxEdge: [45, 34, 26], fee: 3.08, unit: 'g' },
            { tierName: 'Standard Parcel (400g)', maxWeight: 0.4, maxEdge: [45, 34, 26], fee: 3.42, unit: 'g' },
        ],
        lowPrice: [
            { tierName: 'Small Envelope (80g)', maxWeight: 0.08, maxEdge: [20, 15, 1], fee: 1.55, unit: 'g' },
            { tierName: 'Standard Envelope (100g)', maxWeight: 0.1, maxEdge: [33, 23, 2.5], fee: 1.75, unit: 'g' },
            { tierName: 'Standard Parcel (150g)', maxWeight: 0.15, maxEdge: [45, 34, 26], fee: 2.55, unit: 'g' },
        ]
    }
};

export const FR_CONFIG: SiteConfig = {
    currency: '€',
    lowPriceThreshold: 11.00,
    storageFees: {
        standard: { jan_sep: 26.00, oct_dec: 31.00, unit: 'cbm' },
        oversize: { jan_sep: 18.00, oct_dec: 22.00, unit: 'cbm' }
    },
    sizeTiers: {
        standard: [
            { tierName: 'Small Envelope (80g)', maxWeight: 0.08, maxEdge: [20, 15, 1], fee: 2.33, unit: 'g' },
            { tierName: 'Standard Parcel (150g)', maxWeight: 0.15, maxEdge: [45, 34, 26], fee: 4.05, unit: 'g' },
        ],
        lowPrice: []
    }
};

export const IT_CONFIG: SiteConfig = {
    currency: '€',
    lowPriceThreshold: 11.00,
    storageFees: {
        standard: { jan_sep: 26.00, oct_dec: 31.00, unit: 'cbm' },
        oversize: { jan_sep: 18.00, oct_dec: 22.00, unit: 'cbm' }
    },
    sizeTiers: {
        standard: [
            { tierName: 'Small Envelope (80g)', maxWeight: 0.08, maxEdge: [20, 15, 1], fee: 2.65, unit: 'g' },
            { tierName: 'Standard Parcel (150g)', maxWeight: 0.15, maxEdge: [45, 34, 26], fee: 4.05, unit: 'g' },
        ],
        lowPrice: []
    }
};

export const ES_CONFIG: SiteConfig = {
    currency: '€',
    lowPriceThreshold: 11.00,
    storageFees: {
        standard: { jan_sep: 26.00, oct_dec: 31.00, unit: 'cbm' },
        oversize: { jan_sep: 18.00, oct_dec: 22.00, unit: 'cbm' }
    },
    sizeTiers: {
        standard: [
            { tierName: 'Small Envelope (80g)', maxWeight: 0.08, maxEdge: [20, 15, 1], fee: 2.40, unit: 'g' },
            { tierName: 'Standard Parcel (150g)', maxWeight: 0.15, maxEdge: [45, 34, 26], fee: 3.95, unit: 'g' },
        ],
        lowPrice: []
    }
};
